import * as React from 'react'

import { format } from 'date-fns'
import { es } from 'date-fns/locale'
import { Calendar as CalendarIcon } from 'lucide-react'

import { cn } from '@/shared/lib/styles/class-merge'
import { Button } from '@/shared/ui/button'
import { Calendar } from '@/shared/ui/calendar'
import { Popover, PopoverContent, PopoverTrigger } from '@/shared/ui/popover'

export interface DatePickerProps {
    date?: Date
    onSelect: (date: Date | undefined) => void
    className?: string
    disabled?: boolean
}

export function DatePicker({ date, onSelect, className, disabled = false }: DatePickerProps) {
    return (
        <Popover>
            <PopoverTrigger asChild>
                <Button
                    variant={'outline'}
                    className={cn(
                        'w-[230px] justify-start text-left font-normal',
                        !date && 'text-muted-foreground',
                        className,
                    )}
                    disabled={disabled}
                >
                    <CalendarIcon className='mr-2 h-4 w-4' />
                    {date ? format(date, 'PPP', { locale: es }) : <span>Seleccionar fecha</span>}
                </Button>
            </PopoverTrigger>
            <PopoverContent className='w-auto p-0' align='start'>
                <Calendar
                    mode='single'
                    selected={date}
                    onSelect={onSelect}
                    initialFocus
                    disabled={disabled}
                    defaultMonth={date}
                />
            </PopoverContent>
        </Popover>
    )
}
